module.exports = __webpack_public_path__ + "static/media/pay-later-activate.36c5fed7.svg";